import React from 'react';
import ReactDOM from 'react-dom/client';
import Konva from 'konva';
import App from './App';

// Konva renders every layer's canvas at window.devicePixelRatio. On a 3x DPR
// phone (iPhone 16 Pro Max) that's ~9x the pixels per redraw — the main reason
// even a flagship feels laggy. Cap at 2: still retina-sharp, ~half the fill
// cost. Desktop / TV are usually <=2 DPR, so this is a no-op there.
Konva.pixelRatio = Math.min(window.devicePixelRatio || 1, 2);

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
